import React from "react"
import { DropdownChevron } from "../icon/DropdownChevron"
import gbflag from "../../../assets/gb-flag.png"
import ireFlag from "../../../assets/ire-flag.jpg"
import { renderToStaticMarkup } from "react-dom/server"
import { findCountryFlag } from "./getCountry"
import { UseFormMethods, ValidationRules } from "react-hook-form"

const stringifySvg = encodeURIComponent(
  renderToStaticMarkup(<DropdownChevron colour="#051C2C" />)
)

export const countryOptions = (countryCode: any, countries: any) => {
  return countries.map((country: any) => {
    const label =
      countryCode === country.countryCode
        ? country.countryCode
        : `${country.countryCode}`
    return (
      <option label={label} value={country.countryCode} key={country.country}>
        {label}
      </option>
    )
  })
}
interface CountryFlagProps
  extends Partial<Pick<UseFormMethods, "register" | "errors">> {
  rules?: ValidationRules
  name: string
  label?: string
  className?: string
  onChange?: (props: any) => void
  defaultValue?: string | number
  placeholder?: string
  countryCode: string
}

const CountryFlag = ({
  name,
  countryCode,
  onChange,
  register,
}: CountryFlagProps) => {
  const countries = [
    { country: "UK", countryCode: "+44", flag: gbflag },
    { country: "IRE", countryCode: "+353", flag: ireFlag },
  ]

  return (
    <>
      <div>
        <div>
          <select
            className="flag-select"
            name={name}
            defaultValue={countryCode}
            onChange={onChange}
            ref={register}
            style={{
              backgroundImage: `url('data:image/svg+xml,${stringifySvg}')`,
              backgroundPosition: "52px center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {countryOptions(countryCode, countries)}
          </select>
        </div>
        <span
          className="flag"
          style={{
            backgroundImage: `url(${findCountryFlag(countryCode, countries)})`,
            backgroundSize: "36px",
          }}
        />
      </div>
    </>
  )
}

export { CountryFlag }
